const encodeUriParams = (parameters: object): string => {
  let queryString: string = "?";

  for (const key in parameters) {
    const parameter = encodeURIComponent(parameters[key]);

    if (queryString !== "?") {
      queryString += "&";
    }

    queryString += `${key}=${parameter}`;
  }

  return queryString;
};

export default encodeUriParams;
